import { queryKeys } from "../queryKeys";
import { getTrustedAccount, type TrustedContact } from "../rest/account";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetTrustedContact = ({
  accountID = "",
  options,
}: {
  accountID?: string;
  options?: QueryOptions<TrustedContact | null>;
}) => {
  const {
    data: details,
    refetch,
    isFetched,
  } = useRequest(
    queryKeys.trustedContact(accountID || ""),
    () => getTrustedAccount(accountID),
    {
      ...options,
      refetchInterval: false,
    },
  );

  return { trusted_contact: details, refetch, isFetched };
};

export default useGetTrustedContact;
